<template>
  <svg xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      viewBox="0 0 47 60"
      role="presentation"
      @click="$emit('click')">
      <g fill="#F7EC34" fill-rule="evenodd" stroke="#232021">
        <path d="M37.5 53.79c-1.78 0-3.224-1.424-3.224-3.182 0-1.759 1.443-3.184 3.224-3.184 1.78 0 3.223 1.425 3.223 3.184 0 1.758-1.443 3.182-3.223 3.182m2.294-11.925V1.835c0-.46-.379-.835-.846-.835h-2.896a.84.84 0 0 0-.846.835v.988c0 .462-.38.836-.847.836H32.22a.84.84 0 0 0-.845.834v.564c0 .461.378.835.845.835.468 0 .847.374.847.835v1.94c0 .46-.38.835-.847.835a.84.84 0 0 0-.845.835v1.483a.84.84 0 0 0 .845.835h2.14c.467 0 .846.374.846.835v28.375c0 .398-.265.736-.645.874-3.27 1.19-5.598 4.304-5.56 7.955.045 4.436 3.762 8.177 8.253 8.303C42.06 59.13 46 55.323 46 50.607c0-3.613-2.316-6.687-5.562-7.868-.378-.138-.644-.476-.644-.874M11 14.107c0-3.18-2.848-5.683-6.08-4.991-1.883.403-3.406 1.953-3.804 3.873-.492 2.372.628 4.54 2.45 5.579.315.18.48.548.438.914L2.448 32.946A.936.936 0 0 0 3.365 34H8.77a.936.936 0 0 0 .919-1.054L8.122 19.403a.93.93 0 0 1 .425-.905A5.12 5.12 0 0 0 11 14.108"/>
      </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>